import { render } from "./AboutUsTextarea.vue?vue&type=template&id=a78173c0&lang=pug"
import script from "./AboutUsTextarea.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutUsTextarea.vue?vue&type=script&setup=true&lang=js"

import "./AboutUsTextarea.vue?vue&type=style&index=0&id=a78173c0&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__